var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"AppImage",style:(_vm.style),attrs:{"data-src":_vm.lazySrc,"data-srcset":_vm.lazySrcset,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }